import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import UserProfile from "../../services/user_profile.service";
import * as Yup from "yup";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
import { useEffect } from "react";
import CommonService from "../../services/common.service";
import PreviewImage from "../../Component/PreviewImage";
import ToastComponent from "../Common/TaostComponent";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Loader from "../Common/Loader";

const UpdateProfile = () => {
  const [hearAboutList, setHearAboutUs] = useState([]);
  const [result, setResult] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [batStyle, setBatStyle] = useState([]);
  const [bowlStyle, setBowlStyle] = useState([]);
  const [gameList, setGameList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [introductionText, setIntroductionText] = useState("");
  const [batStyleValue, setBatStyleValue] = useState("");
  const [bowlStyleValue, setBowlStyleValue] = useState("");
  const [playerAboutText, setPlayerAboutText] = useState("");
  const [playerInfo, setPlayerInfo] = useState({});
  const [dNoneClass, setDNoneClass] = useState("d-none");
  const [playerId, setPlayerId] = useState("");
  const [gameDataList, setGameDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState();
  useEffect(() => {
    CommonService.getUpdateProfileData().then((res) => {
      if (res.status === 200) {
        setHearAboutUs(res.hear_about_list);
        setResult(res.data);
        setSelectedCountry(res.data?.country);
        setCountryList(res.country_list);
        setStateList(res.state_list);
        setIntroductionText(res.data?.introduction);
        setBatStyle(res.batStyle);
        setBowlStyle(res.bowlStyle);
        setGameList(res.getClubList);
        setGameDataList(res.gameDataListMap);
        seHhearAboutUs(res.data?.about_us);
        setIsLoading(false);
      }
    });
  }, []);
  const handleCountryChange = (e, setFieldValue) => {
    setSelectedCountry(e.target.value);
    setFieldValue("country", selectedCountry);
    CommonService.getStateFromCountryId(e.target.value).then((res) => {
      if (res.status === 200) {
        setStateList(res.data);
      }
    });
  };
  const handleIntroText = (e) => {
    setIntroductionText(e.target.value);
  };
  const handlePlayerAboutText = (e) => {
    setPlayerAboutText(e.target.value);
  };
  const navigate = useNavigate();
  const initialValues = {
    introduction: result?.introduction || "",
    tagline: result?.tagline || "",
    first_name: result?.first_name || "",
    last_name: result?.last_name || "",
    game_name: result?.senior_club_name || "",
    gender: result?.gender || "",
    about_us: result?.about_us || "",
    email: result?.email || "",
    dob: result?.dob || "",
    country: result?.country || "",
    state: result?.state || "",
    city: result?.city || "",
    team_name: result?.my_team_name || "",
    facebook: result?.facebook || "",
    twitter: result?.twitter || "",
    instagram: result?.instagram || "",
    website: result?.website || "",
    image: "",
    bat_style: result?.bat_style,
    bowl_style: result?.bowl_style,
    player_about: result?.player_about,
    player_image: result?.player_image ?? "",
    phone: result?.phone ? result?.phone.toString() : "",
  };
  const [loading, setLoading] = useState(false);
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/png",
    "image/jpeg",
    "image/gif",
  ];
  const validationSchema = Yup.object({
    // email: Yup.string()
    //   .email("Invalid email format")
    //   .required("Email field is required."),
    first_name: Yup.string().required("First Name is required."),
    last_name: Yup.string().required("Last Name is required."),
    game_name: Yup.string().required("Fantasy Hub is required."),
    team_name: Yup.string()
      .max(36, "Team Name cannot be more than 30 characters.")
      .required("Team Name is required."),
    gender: Yup.string().required("Gender is required."),
    // phone: Yup.string()
    //   .required("Phone number is required")
    //   .min(8, "Phone number is too short")
    //   .max(15, "Phone number is too long"),
    phone: Yup.string()
      .required("Phone number is required")
      .test("hasCountryCode", "Please select a country code", function (value) {
        // Check if phone number starts with '+' (indicating a country code)
        if (value) {
          return true;
        }
        return false;
      }),
    country: Yup.string().required("Country is required."),
    // about_us: Yup.string().required("Hear About us is required."),
    dob: Yup.string().required("DOB is required."),
    image: Yup.mixed()
      .nullable(true)
      .test(
        "fileSize",
        "File size too large, max file size is 5 Mb",
        (file) => {
          if (file) {
            return file.size <= 5500000;
          } else {
            return true;
          }
        }
      )
      .test(
        "type",
        "Invalid file format selection",
        (value) =>
          // console.log(value);
          !value || (value && SUPPORTED_FORMATS.includes(value?.type))
      ),
  });
  const onSubmit = (formValue, values) => {
    var formData = new FormData();
    formData.append("introduction", introductionText);
    formData.append("player_about", playerAboutText);
    formData.append("tagline", formValue.tagline);
    formData.append("first_name", formValue.first_name);
    formData.append("last_name", formValue.last_name);
    formData.append("gender", formValue.gender);
    formData.append("about_us", formValue.about_us);
    formData.append("email", formValue.email);
    formData.append("dob", formValue.dob);
    formData.append("phone", formValue.phone);
    formData.append("country", selectedCountry);
    formData.append("state", formValue.state);
    formData.append("city", formValue.city);
    formData.append("team_name", formValue.team_name);
    formData.append("facebook", formValue.facebook);
    formData.append("twitter", formValue.twitter);
    formData.append("instagram", formValue.instagram);
    formData.append("website", formValue.website);
    formData.append("image", formValue.image);
    formData.append("bat_style", formValue.bat_style);
    formData.append("bowl_style", formValue.bowl_style);
    formData.append("player_image", formValue.player_image);
    formData.append("game_name", formValue.game_name);
    formData.append("playerId", playerId);
    CommonService.saveUpdateProfile(formData).then((res) => {
      if (res.status === 200) {
        localStorage.setItem("user", JSON.stringify(res.data));
        ToastComponent(res.message, "success");
        navigate("/my-games");
      }
    });
  };
  const [startDate, setStartDate] = useState(new Date());
  const [hearAboutUs, seHhearAboutUs] = useState();
  const handleDateChange = (date, setFieldValue) => {
    setStartDate(date);
    setFieldValue("dob", "start_date", moment(date).format("YYYY-MM-DD"));
  };
  const handleHereAboutUs = (value) => {
    seHhearAboutUs(value.target.value);
  };
  const handleProfile = (e, setFieldValue) => {
    setFieldValue("image", e.target.files[0]);
  };
  const handlePlayerImage = (e, setFieldValue) => {
    setFieldValue("player_image", e.target.files[0]);
  };
  const imagePath = process.env.REACT_APP_USER_PROFILE + result.image;
  const handleGameChange = (e) => {
    UserProfile.getPlayerUserProfile(e.target.value).then((res) => {
      if (res.status === 200) {
        setPlayerInfo(res.data);
        setDNoneClass("");
        setPlayerId(res.playerId);
        setBatStyleValue(res.data?.bat_style);
        setBowlStyleValue(res.data?.bowl_style);
        setPlayerAboutText(res.data?.description);
      }
    });
  };

  const [phoneValue, setPhoneValue] = useState();

  return isLoading ? (
    <Loader />
  ) : (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Edit Profile</h2>
          </div>
          {!result?.is_profile_completed && (
            <p style={{ color: "white" }}>
              <center>
                {" "}
                <i>
                  Please fill the *required fields to complete profile and
                  access My Games.
                </i>{" "}
              </center>
            </p>
          )}

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ errors, handleChange, values, touched, setFieldValue }) => (
              <Form>
                <div>
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label
                                htmlFor="fantasy_hub"
                                className="pb-2 fw-bold"
                              >
                                My Fantasy Hub*
                              </label>

                              <Select
                                options={gameDataList}
                                isSearchable={true}
                                placeholder="Select a game"
                                value={gameDataList.find(
                                  (option) => option.value === values.game_name
                                )}
                                onChange={(option) =>
                                  setFieldValue("game_name", option.value)
                                }
                              />
                              {touched.game_name && errors.game_name && (
                                <span className="help-inline error">
                                  {errors.game_name}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label
                                htmlFor="team_name"
                                className="pb-2 fw-bold"
                              >
                                My Team Name*
                              </label>
                              <Field
                                name="team_name"
                                type="text"
                                className="form-control"
                                placeholder="Set Your Fantasy Team Name*"
                              />
                              {touched.team_name && errors.team_name && (
                                <span className="help-inline error">
                                  {errors.team_name}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2">
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="country" className="pb-2 fw-bold">
                                First Name*
                              </label>
                              <Field
                                name="first_name"
                                type="text"
                                className="form-control"
                                placeholder="First Name*"
                                onChange={handleChange}
                                id={"first_name"}
                              />
                              {touched.first_name && errors.first_name && (
                                <span className="help-inline error">
                                  {errors.first_name}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="country" className="pb-2 fw-bold">
                                Last Name*
                              </label>
                              <Field
                                name="last_name"
                                type="text"
                                className="form-control"
                                placeholder="Last Name*"
                              />
                              {touched.last_name && errors.last_name && (
                                <span className="help-inline error">
                                  {errors.last_name}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="phone" className="pb-2 fw-bold">
                                Phone*
                              </label>
                              <PhoneInput
                                // country={"au"} // Default country
                                value={values.phone}
                                autoFormat="false"
                                onChange={(phone) =>
                                  setFieldValue("phone", phone)
                                }
                                inputProps={{
                                  name: "phone",
                                  required: true,
                                  autoFocus: true,
                                  // autoComplete: "tel",
                                  className: `form-control ${
                                    touched.phone && errors.phone
                                      ? "is-invalid"
                                      : ""
                                  }`,
                                }}
                                inputStyle={{
                                  height: "55px", // Adjust height as needed
                                  width: "100%",
                                  border: "1px solid #0A0F2E", // Adjust border style as needed
                                  // borderRadius: "55px", // Adjust border radius as needed
                                }}
                              />
                              {touched.phone && errors.phone && (
                                <span className="help-inline error">
                                  {errors.phone}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="dob" className="pb-2 fw-bold">
                                DOB*
                              </label>
                              <br></br>
                              <DatePicker
                                name="dob"
                                selected={startDate}
                                onChange={(date) =>
                                  handleDateChange(date, setFieldValue)
                                }
                                className="form-control"
                                dateFormat={"dd/MM/yyyy"}
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                adjustDateOnChange
                              />
                              {touched.dob && errors.dob && (
                                <span className="help-inline error">
                                  {errors.dob}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="gender" className="pb-2 fw-bold">
                                Gender*
                              </label>
                              <Field
                                as="select"
                                name="gender"
                                className="form-control"
                              >
                                <option value="">Select Gender</option>
                                <option value="1">Male</option>
                                <option value="2">Female</option>
                                <option value="3">
                                  Do not wish to specify
                                </option>
                              </Field>
                              {touched.gender && errors.gender && (
                                <span className="help-inline error">
                                  {errors.gender}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="country" className="pb-2 fw-bold">
                                Country*
                              </label>
                              <Field
                                as="select"
                                name="country"
                                className="form-control"
                                onChange={(e) =>
                                  handleCountryChange(e, setFieldValue)
                                }
                                value={selectedCountry}
                              >
                                <option value="">Select Country</option>
                                {countryList?.length >= 0 &&
                                  countryList.map((item, key) => (
                                    <option
                                      value={item?.id}
                                      key={key}
                                      id={item.id}
                                    >
                                      {item?.name}
                                    </option>
                                  ))}
                              </Field>

                              {touched.country && errors.country && (
                                <span className="help-inline error">
                                  {errors.country}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="state" className="pb-2 fw-bold">
                                State
                              </label>
                              <Field
                                as="select"
                                name="state"
                                className="form-control"
                                // value={selectedCountry}
                              >
                                <option value="">Select State</option>
                                {stateList &&
                                  stateList.map((item, key) => (
                                    <option
                                      value={item?.id}
                                      key={key}
                                      id={item.id}
                                    >
                                      {item?.name}
                                    </option>
                                  ))}
                              </Field>
                              {touched.state && errors.state && (
                                <span className="help-inline error">
                                  {errors.state}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="city" className="pb-2 fw-bold">
                                City
                              </label>
                              <Field
                                name="city"
                                type="text"
                                className="form-control"
                                placeholder="City*"
                              />
                              {touched.city && errors.city && (
                                <span className="help-inline error">
                                  {errors.city}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label
                                htmlFor="about_us"
                                className="pb-2 fw-bold"
                              >
                                Heard About Us
                              </label>
                              <Field
                                as="select"
                                name="about_us"
                                className="form-control pt-2"
                                onChange={(e) => {
                                  handleHereAboutUs(e);
                                  setFieldValue("about_us", e.target.value);
                                }}
                                value={hearAboutUs}
                              >
                                <option value="">Heard about us?</option>
                                {hearAboutList &&
                                  hearAboutList.map((item, key) => (
                                    <option
                                      value={item?.id}
                                      key={key}
                                      id={item.id}
                                    >
                                      {item?.name}
                                    </option>
                                  ))}
                              </Field>
                              {touched.about_us && errors.about_us && (
                                <span className="help-inline error">
                                  {errors.about_us}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2">
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label
                                htmlFor="introduction"
                                className="pb-2 fw-bold"
                              >
                                Introduction
                              </label>
                              <Field
                                name="introduction"
                                as="textarea"
                                className="form-control"
                                placeholder="Introduction"
                                value={introductionText}
                                id="introduction"
                                onChange={handleIntroText}
                              />
                              {touched.introduction && errors.introduction && (
                                <span className="help-inline error">
                                  {errors.introduction}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="tagline" className="pb-2 fw-bold">
                                Tagline
                              </label>
                              <Field
                                name="tagline"
                                type="text"
                                className="form-control"
                                placeholder="Tagline"
                              />
                              {touched.tagline && errors.tagline && (
                                <span className="help-inline error">
                                  {errors.tagline}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="dob" className="pb-2 fw-bold">
                                Profile Picture
                              </label>
                              <div className="form-control customfiletype">
                                <input
                                  name="image"
                                  type="file"
                                  value=""
                                  placeholder="Image"
                                  onChange={(e) =>
                                    handleProfile(e, setFieldValue)
                                  }
                                />
                                <Link>Upload</Link>
                              </div>

                              {touched.image && errors.image && (
                                <span className="help-inline error">
                                  {errors.image}
                                </span>
                              )}
                            </div>

                            {values.image ? (
                              <PreviewImage
                                className="asdasd"
                                width={100}
                                height={100}
                                file={values.image}
                              />
                            ) : result?.image ? (
                              <img
                                className="else"
                                src={`${imagePath}`}
                                width={100}
                                height={100}
                                alt="Preview"
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2">
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className="row">
                          <div className="col-sm-6">
                            <label htmlFor="facebook" className="pb-2 fw-bold">
                              Facebook
                            </label>
                            <div className="form-group">
                              <Field
                                name="facebook"
                                type="text"
                                className="form-control"
                                placeholder="Facebook"
                              />
                              {touched.facebook && errors.facebook && (
                                <span className="help-inline error">
                                  {errors.facebook}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="twitter" className="pb-2 fw-bold">
                                Twitter
                              </label>
                              <Field
                                name="twitter"
                                type="text"
                                className="form-control"
                                placeholder="Twitter"
                              />
                              {touched.twitter && errors.twitter && (
                                <span className="help-inline error">
                                  {errors.twitter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label
                                htmlFor="instagram"
                                className="pb-2 fw-bold"
                              >
                                Instagram
                              </label>
                              <Field
                                name="instagram"
                                type="text"
                                className="form-control"
                                placeholder="Instagram"
                              />
                              {touched.instagram && errors.instagram && (
                                <span className="help-inline error">
                                  {errors.instagram}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="website" className="pb-2 fw-bold">
                                Website
                              </label>
                              <Field
                                name="website"
                                type="text"
                                className="form-control"
                                placeholder="Website"
                              />
                              {touched.website && errors.website && (
                                <span className="help-inline error">
                                  {errors.website}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pt-2">
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className={`row`}>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="country" className="pb-2 fw-bold">
                                My Verified Player Profile
                              </label>
                              <Field
                                as="select"
                                name="game_name1"
                                className="form-control"
                                onChange={handleGameChange}
                              >
                                <option value="">Select Game</option>
                                {gameList &&
                                  gameList.map((item, key) => (
                                    <option value={item?.id} key={key}>
                                      {item?.game_name}
                                    </option>
                                  ))}
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div className={`row ${dNoneClass}`}>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="city" className="pb-2 fw-bold">
                                Player Profile Photo
                              </label>
                              <div className="form-control customfiletype">
                                <input
                                  name="player_image"
                                  type="file"
                                  value=""
                                  onChange={(e) =>
                                    handlePlayerImage(e, setFieldValue)
                                  }
                                />
                                <Link>Upload</Link>
                              </div>

                              {touched.player_image && errors.player_image && (
                                <span className="help-inline error">
                                  {errors.player_image}
                                </span>
                              )}
                            </div>

                            {values.player_image ? (
                              <PreviewImage
                                className="preview-image" // Added class name for styling if needed
                                width={100}
                                height={100}
                                file={values.player_image}
                              />
                            ) : playerInfo?.is_avatar === 1 ? (
                              <img
                                src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${playerInfo.player_image}`}
                                alt="Avatar"
                                width={100}
                                height={100}
                              />
                            ) : (
                              <img
                                src={`${process.env.REACT_APP_UPLOAD_URL}player/${playerInfo.player_image}`}
                                alt="Player"
                                width={100}
                                height={100}
                              />
                            )}
                          </div>
                          <div className="col-sm-12 pt-2">
                            <div className="form-group">
                              <label
                                htmlFor="about_me"
                                className="pb-2 fw-bold"
                              >
                                About Me
                              </label>
                              <Field
                                name="player_about"
                                as="textarea"
                                className="form-control"
                                placeholder="About me"
                                value={playerAboutText}
                                id="player_about"
                                onChange={handlePlayerAboutText}
                              />
                              {touched.player_about && errors.player_about && (
                                <span className="help-inline error">
                                  {errors.player_about}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2">
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <div className="text-center">
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfile;
